export default __webpack_public_path__ + "static/media/ic-arrowWhite.7cef327b.svg";